import React from "react";
import { useParams } from "react-router-dom";

import config from "../../../config/config";

import "./AnalyticalMethods.scss";

const CKDAnalyticalMethods2023 = () => {
  const { year } = useParams();

  const download = (refNum) => {
    const url = `${config.baseUri}/analyticalMethods?year=${year}&fileName=${refNum}&volumeNumber=1`;
    window.location = url;
  };

  return (
    <div>
      <h1>Analytical Methods</h1>
      <ul>
        <li>
          <button onClick={() => download("Volume 1 Methods")}>
            Data Sources and Methods for CKD Volume
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes_for_Hospitalization_Causes_-_CKD_Volume_2023")
            }
          >
            Codes for Hospitalization Causes - CKD Volume
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes_and_Algorithm_for_Common_CVDs_2023")
            }
          >
            Codes and Algorithm for CVD and Procedure
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Comorbidity_and_CKD_2023")}>
            Codes for Comorbidity and CKD
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes_for_Comorbidity_and_Kidney_Disorders_in_Children_2023")
            }
          >
            Codes for Comorbidity and Kidney Disorders in Children
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CKDAnalyticalMethods2023;
